module.exports = __webpack_public_path__ + "img/DSC_0055.ece2fd97.jpg";